/// <reference path="DOMAttached.js" />
/// <reference path="ProgressIndicator.js" />
/// <reference path="GenericSounds.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />
/// <reference path="LegacyHelper.js" />

var blocked = new Boolean(false);

class TabbedApplication extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.el.attachedObj = this;
		this.progressIndicator = new ProgressIndicator(this.el);
		this.tabs = document.querySelectorAll('.tabappTab:not(.mia-feedbackSoundTab)');
		this.links = options.tabLinks;
		this.playFeedbackSound = options.playFeedbackSound;
		this.content = this.el.querySelector('.contentPane');
		this.currentTab = this.tabs[0];
		this.currentTab.classList.add('selected');
		this.selectTab(0);

		for (let i = 0; i < this.tabs.length; i++) {
			this.safeObserve(this.tabs[i], 'click', () => this.loadTab(i));
		}

		this.registerLinks();

		if (GenericSoundsInstance == null) {
			GenericSoundsInstance = new GenericSounds(this.playFeedbackSound);
		}

		GenericSoundsInstance.introSound();

		if (this.options.defaultPage != undefined) {
			this.loadPage(this.options.defaultPage);
		}
	}

	registerLinks() {
		var links = this.el.querySelector('.contentPane').querySelectorAll('a.tabLink');
		for (let i = 0; i < links.length; i++) {
			this.safeObserve(links[i], 'click', (ev) => this.onClickLink(ev, links[i].href));
		}
	}

	onClickLink(ev, url) {
		if (!this.blocked) {
			ev.preventDefault();
			ev.stopPropagation();
			this.loadPage(url);
		}
	}

	registerTimer(timer) {
		this.timer = timer;
	}

	registerInterval(interval) {
		this.interval = interval;
	}

	loadPage(url) {
		if (!this.blocked)
			this.loadPageWithOwnSuccessHandler(url, this.onPageLoaded.bind(this));
	}

	loadPageWithOwnSuccessHandler(url, onSuccessHandler) {
		this.progressIndicator.showProgressIndicator(true, false);

		if (this.timer != undefined) {
			try {
				clearTimeout(this.timer);
			} finally {
				this.timer = undefined;
			}
		}

		if (this.interval != undefined) {
			try {
				clearInterval(this.interval);
			} finally {
				this.interval = undefined;
			}
		}

		axios(url, {
			method: 'get'
		}).then(onSuccessHandler);
	}

	loadTab(index) {
		if (!this.blocked) {
			soundManager.stopAll();
			GenericSoundsInstance.clickSound();
			if (index == 3) {
				GenericSoundsInstance.shopSound();
			}
		}
		this.selectTab(index);
		this.loadPage(this.links[index]);
	}

	findTab(url) {
		for (var i = 0; i < this.links.length; ++i) {
			if (this.links[i] == url) {
				return i;
			}
		}
		return -1;
	}

	findAndLoadTab(url) {
		this.loadTab(this.findTab(url));
	}

	selectTab(index) {
		if (!this.blocked) {
			this.currentTab.classList.remove("selected");
			this.currentTab = this.tabs[index];
			this.currentTab.classList.add("selected");
		}
	}

	activatePlaceholder(name, caption, url) {
		for (var i = 0; i < this.tabs.length; i++) {
			if (this.tabs[i].id.endsWith('_' + name)) {
				this.tabs[i].innerHTML = caption;
				this.links[i] = url;

				this.tabs[i].style.display = 'block';
				this.selectTab(i);
				break;
			}
		}
	}

	onPageLoaded(req) {
		var json = req.data;

		if (json.success) {
			if (json.successpopup != undefined) {
				this.el.querySelector('.popupContainer').attachedObj.showContent(json.successpopup);
				this.progressIndicator.hideProgressIndicator();
				return;
			}

			this.content.innerHTML = json.page;
			evalScripts(this.content);
			this.registerLinks();
		} else {
			//Does it come with a message popup?
			if (json.errorpopup != undefined) {
				this.el.querySelector('.popupContainer').attachedObj.showContent(json.errorpopup);
				this.progressIndicator.hideProgressIndicator();
				return;
			}

			this.content.innerHTML = '<b>Could not load page. Try again!</b>';
		}

		this.progressIndicator.hideProgressIndicator();
	}
}
